module.exports = __webpack_public_path__ + "static/img/logo3.79939aca.png";